module.exports = __webpack_public_path__ + "img/IMG_8473_FoamcoreMatted.9db3895e.jpg";